import React, { createContext, useContext, ReactNode } from 'react';
import { useWorkspace, Workspace, WorkspaceMember } from '@/hooks/useWorkspace';

interface WorkspaceContextType {
  workspaces: Workspace[];
  activeWorkspace: Workspace | null;
  members: WorkspaceMember[];
  userRole: WorkspaceMember['role'] | null;
  loading: boolean;
  error: string | null;
  switchWorkspace: (workspace: Workspace) => void;
  isOwnerOrAdmin: boolean;
  refetchWorkspaces: () => Promise<void>;
}

const WorkspaceContext = createContext<WorkspaceContextType | undefined>(undefined);

export function WorkspaceProvider({ children }: { children: ReactNode }) {
  const workspaceData = useWorkspace();

  return (
    <WorkspaceContext.Provider value={workspaceData}>
      {children}
    </WorkspaceContext.Provider>
  );
}

export function useWorkspaceContext() {
  const context = useContext(WorkspaceContext);
  if (context === undefined) {
    throw new Error('useWorkspaceContext must be used within a WorkspaceProvider');
  }
  return context;
}
